import { render, staticRenderFns } from "./m-edit-css-property-dialog.vue?vue&type=template&id=4700c4ef&scoped=true&"
import script from "./m-edit-css-property-dialog.vue?vue&type=script&lang=js&"
export * from "./m-edit-css-property-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700c4ef",
  null
  
)

export default component.exports